// -- [CTA section - Get demo]

import { useState } from 'react'
import type { CtaConfig } from '@/types/content'
import { Button, SuccessTickIcon } from '@/components/ui/Button'
import { Section } from '@/components/ui/Section'

// -- [A/B-style subheadline: one chosen at random on each page load]
const CTA_SUBHEADLINE_OPTIONS = [
  'See it with my own deals.',
  'Try it free, no lock-in.',
  'Show me how it works.',
  'Start scanning this week.',
  'Get my team on Drivible.',
  'See the search in action.',
  'Talk to someone who gets dealers.',
  'Skip the filing and sorting.',
  'See how fast an audit can be.',
]

interface CtaSectionProps {
  cta: CtaConfig
  onOpenSignup: (source: string) => void
  /** -- When true, primary button shows green success + tick (already submitted) */
  hasSubmittedDemo?: boolean
}

export function CtaSection({ cta, onOpenSignup, hasSubmittedDemo = false }: CtaSectionProps) {
  const [subheadline] = useState(
    () => CTA_SUBHEADLINE_OPTIONS[Math.floor(Math.random() * CTA_SUBHEADLINE_OPTIONS.length)]
  )
  return (
    <Section id="contact" bg="muted" narrow className="text-center">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 motion-enter">
        {cta.headline}
      </h2>
      <p className="text-ink-muted mb-8">{subheadline}</p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Button
          variant={hasSubmittedDemo ? 'success' : 'primary'}
          onClick={() => onOpenSignup(cta.primaryButtonText)}
          data-umami-event="Book a demo"
          className="px-6"
        >
          {hasSubmittedDemo && <SuccessTickIcon className="h-5 w-5 shrink-0" />}
          {cta.primaryButtonText}
        </Button>
      </div>
    </Section>
  )
}
